import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import moment from 'moment'
import Numeral from 'numeral'

import routeActions from 'actions/routeActions'
import { tenantLedger } from 'selectors/tenant'
import { leaseByTenantID } from 'selectors/lease'

import Section from 'components/Section'
import AddButton from '../transactionForm/AddPaymentButton'

import { Column, Table, AutoSizer  } from 'react-virtualized'
import MenuItem from 'material-ui/MenuItem'
import 'react-virtualized/styles.css'
import calcTable from 'utils/calcTable'

let select = (state, props) => ({
	transactions: tenantLedger(state, props)
  , leaseByTenantID: leaseByTenantID(state, props)
})


export class Ledger extends Component{
	render(){
		let { props } = this
		let height = (props.transactions.length + 1) * 48
		let cols = {
			date: 120
		  , type: {min: 130, avg: 160}
		  , debit: 63
		  , credit: 63
		  , balance: 63
		}
		let width = props.width || window.screen.width / 2
		cols = calcTable(parseInt(width), cols)
		return(
			<Section
				id="tenant/ledger"
				title={
					<div>
						<span>
							Balance: $
							{
								Numeral(props.transactions[0] && props.transactions[0].balance || '0').format('0.')
							}
						</span>
						<span style={{marginLeft:"5px"}}>
							{
								props.transactions[0] && props.transactions[0].refund > 0
								?'Deposit refund: $'+(props.transactions[0].refund)
								:props.transactions[0] && props.transactions[0].deposit<props.transactions[0].payments
								?'Deposit paid: $'+(props.transactions[0].deposit || 0)
								:props.transactions[0] && props.transactions[0].payments == 0
								?'Deposit not paid: $'+(props.transactions[0].deposit || 0)
								:props.transactions[0] && props.transactions[0].deposit>props.transactions[0].payments
								?'Deposit paid: $'+(props.transactions[0].payments || 0)+' of $'+(props.transactions[0].deposit || 0)
								:null
							}
						</span>
					</div>
				}
				rightButton={
					<AddButton>
						<MenuItem value="Payment" object={{
							type:'transaction/invoice-payment'
						  , partyID:props.tenantID
  						  , amount: (props.transactions[0] && props.transactions[0].balance > 0) ? props.transactions[0].balance : 0
  						  , propertyID: props.transactions[0] && props.transactions[0].propertyID || (props.lease? props.lease.propertyID : (props.leaseByTenantID[props.tenantID] && props.leaseByTenantID[props.tenantID].propertyID))
  						  , date: new Date()
						}} primaryText="Payment" />
						<MenuItem value="Credit" object={{
							type:'transaction/credit'
						  , partyID:props.tenantID
						  , amount: 0
						  , propertyID: props.transactions[0] && props.transactions[0].propertyID || (props.lease? props.lease.propertyID : (props.leaseByTenantID[props.tenantID] && props.leaseByTenantID[props.tenantID].propertyID))
						  , date: new Date()
						}} primaryText="Credit" />
						<MenuItem value="Refund" object={{
							type:'transaction/refund'
						  , partyID:props.tenantID
						  , amount: 0
						  , propertyID: props.transactions[0] && props.transactions[0].propertyID || (props.lease? props.lease.propertyID : (props.leaseByTenantID[props.tenantID] && props.leaseByTenantID[props.tenantID].propertyID))
						  , date: new Date()
						}} primaryText="Refund" />
						<MenuItem value="Deposit use" object={{
							type:'transaction/deposit-use'
						  , partyID:props.tenantID
						  , amount: 0
						  , propertyID: props.transactions[0] && props.transactions[0].propertyID || (props.lease? props.lease.propertyID : (props.leaseByTenantID[props.tenantID] && props.leaseByTenantID[props.tenantID].propertyID))
						  , date: new Date()
						}} primaryText="Deposit use" />
						<MenuItem value="Deposit refund" object={{
							type:'transaction/deposit-refund'
						  , partyID:props.tenantID
						  , amount: 0
						  , propertyID: props.transactions[0] && props.transactions[0].propertyID || (props.lease? props.lease.propertyID : (props.leaseByTenantID[props.tenantID] && props.leaseByTenantID[props.tenantID].propertyID))
						  , date: new Date()
						}} primaryText="Deposit refund" />
						<MenuItem value="Bad debt" object={{
							type:'transaction/bad-debt'
						  , partyID:props.tenantID
						  , amount: 0
						  , propertyID: props.transactions[0] && props.transactions[0].propertyID || (props.lease? props.lease.propertyID : (props.leaseByTenantID[props.tenantID] && props.leaseByTenantID[props.tenantID].propertyID))
						  , date: new Date()
						}} primaryText="Bad debt" />
						<MenuItem value="invoice" object={{
							type:'transaction/invoice'
							, partyID:props.tenantID
							, lines:[]
							, date: new Date()
							, dueDate: new Date().setDate(new Date().getDate()+10)
							, propertyID: props.transactions[0] && props.transactions[0].propertyID || (props.lease? props.lease.propertyID : (props.leaseByTenantID[props.tenantID] && props.leaseByTenantID[props.tenantID].propertyID))
						}} primaryText="Invoice" />

					</AddButton>
				}

			>
				<Table
					width={parseInt(width)-30}
					height={height}
					headerHeight={48}
					rowHeight={48}
					rowCount={props.transactions.length}
					rowClassName={(x)=>{
						if (x.index == -1) {
							return "tableHeaderClass"
						} else {
							return "tableRowClass"
						}
					}}
					rowStyle={({ index }) => ({
						borderBottom: 'none'
					  , borderTop: index > -1 ? '1px #c8c8c8 solid' : 'none'
					})}
					onRowClick = {({ rowData }) => props.NAVIGATE(`transaction/${rowData._id}`)}
					rowGetter={({ index }) => R.reverse(props.transactions ||[])[index]}
				>
					<Column
						width={cols.date}
						label="date"
						dataKey="date"
						cellRenderer={({ cellData }) => moment(cellData).format("DD MMM YYYY")}
					/>
					<Column
						width={cols.type}
						label="type"
						dataKey="named"
						cellRenderer={({ cellData }) => (<div><span>{cellData.name}</span><span style={{fontSize:"14px", marginLeft:"10px", color:"rgb(150,150,150)"}}>{!!cellData.memo && (cellData.memo)}</span></div>)}
					/>
					<Column
						width={cols.debit}
						label="Debit"
						dataKey="debit"
						headerRenderer={()=><div style={{textAlign:"right", width:"100%", height:"19px", paddingRight:"5px"}}>Debit</div>}
						style={{textAlign:"right", paddingRight:"5px"}}
						cellRenderer={({ cellData }) => (
							<div style={{textAlign:"right"}}>
								{cellData && (Numeral(cellData) <0  && '-' || '')+"$" + Numeral(Math.abs(cellData)).format('0,0') || ' '}
							</div>
						)}
					/>
					<Column
						width={cols.credit}
						label="Сredit"
						dataKey="сredit"
						headerRenderer={()=><div style={{textAlign:"right", width:"100%", height:"19px", paddingRight:"5px"}}>сredit</div>}
						style={{textAlign:"right", paddingRight:"5px"}}
						cellRenderer={({ cellData }) => (
							<div style={{textAlign:"right"}}>
								{cellData && (Numeral(cellData) <0  && '-' || '')+"$" + Numeral(Math.abs(cellData)).format('0,0') || ' '}
							</div>
						)}
					/>
					<Column
						width={cols.balance}
						label="balance"
						dataKey="balance"
						headerRenderer={()=><div style={{textAlign:"right", width:"100%", height:"19px", paddingRight:"5px"}}>balance</div>}
						style={{textAlign:"right", paddingRight:"5px"}}
						cellRenderer={({ cellData }) => {return (
							<div style={{textAlign:"right", color: (cellData< 0) ? 'red' : 'black'}}>
								{(cellData < 0 ? '-' : '')+"$" + Numeral(Math.abs(cellData)).format('0,0')}
							</div>
						)}}
					/>
				</Table>

			</Section>
		)
	}
}

export default connect(select, routeActions)(Ledger)



// WEBPACK FOOTER //
// ./src/routes/manager/leaseForm/Ledger.js